import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Resource from 'types/Resource';
import SourceResourceType from 'sources/sourceTypes/Resource';
import * as mapper from 'sources/mapper/Resource';
import { PaginationParams } from 'sources/sourceTypes/Pagination';

export interface ResourceParams extends PaginationParams {
  ids?: number[];
}

class ResourceSource extends BaseSource<
  Resource,
  SourceResourceType,
  ResourceParams
> {
  public ObjectURL = 'resources' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;
}

const resourceSource = new ResourceSource();

export default resourceSource;
